import { render, staticRenderFns } from "./face_asset_comp.vue?vue&type=template&id=2cd27db3&lang=pug&"
import script from "./face_asset_comp.vue?vue&type=script&lang=js&"
export * from "./face_asset_comp.vue?vue&type=script&lang=js&"
import style0 from "./face_asset_comp.vue?vue&type=style&index=0&id=2cd27db3&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports